import React, { Suspense, useState } from 'react';
import useDevice from './hooks/useDevice';
import { Route, Switch, Redirect } from 'react-router-dom';
import getCookie from './components/Queries/getCookie';
////import ReactGA from 'react-ga4';

// Components
import Loadingpage from './components/Loadingpage';
import Sign from './components/Sign';
import Cart from './components/Cart';
import TicketRedirect from './components/TicketRedirect';
import Order from './components/Order';
import OrderMx from './components/OrderMx';
import SessionMessage from './components/SessionMessage';
import Ticket from './components/Ticket';
import Payment from './components/Payment';
import TicketIos from './components/TicketRedirect/TicketIOS';
import ContractIndex from './components/ContractIndex';
import AccountToken from './components/AccountToken';
import MagazineSuccess from './components/Consultancy/MagazineSuccess';

// Hooks
import useGtag from './components/Hooks/useGtag';

//ReactGA.initialize('G-8M3YMGC1JB');

//const webservice = 'https://terramarbrands.mx/wsTerramar/Service1.svc';
const webservice = process.env.REACT_APP_WEBSERVICE;

const Terramar = ({ history, userAgent }) => {
  const device = useDevice({ userAgent });
  const { screenSize = '' } = device || {};

  const pathname = useGtag();

  const [sessionMessage, setSessionMessage] = useState('');
  const [orderData, setOrderData] = useState({});

  return (
    <div className='App'>
      <SessionMessage sessionMessage={sessionMessage} history={history} />
      <Switch>
        <Route
          path='/cart'
          render={(props) => {
            return (
              (getCookie('usuarioOk') &&
                (getCookie(`cartCookie${process.env.REACT_APP_COUNTRY}`) ||
                  getCookie(`cartCookie${process.env.REACT_APP_COUNTRY}`) === 'accepted') && (
                  <Cart
                    {...props}
                    device={device}
                    screenSize={screenSize}
                    history={history}
                    webservice={webservice}
                    getCookie={getCookie}
                    orderData={orderData}
                    setOrderData={setOrderData}
                    setSessionMessage={setSessionMessage}
                    pathname={pathname}
                  />
                )) || <Redirect to={`/`} />
            );
          }}
        />
        <Route
          path='/activateaccount/:accountToken?'
          render={(props) => {
            return <AccountToken {...props} />;
          }}
        />
        <Route
          path='/redirectios'
          render={(props) => {
            return <TicketIos {...props} ostype='ios' />;
          }}
        />
        <Route
          path='/ticketredirectios'
          render={(props) => {
            return (
              <TicketRedirect
                {...props}
                screenSize={screenSize}
                history={history}
                webservice={webservice}
                device={device}
                getCookie={getCookie}
                setSessionMessage={setSessionMessage}
                ostype='ios'
              />
            );
          }}
        />
        <Route
          path='/ticketredirectandroid'
          render={(props) => {
            return (
              <TicketRedirect
                {...props}
                screenSize={screenSize}
                history={history}
                webservice={webservice}
                getCookie={getCookie}
                setSessionMessage={setSessionMessage}
                ostype='android'
              />
            );
          }}
        />
        <Route
          path='/ticketredirect'
          render={(props) => {
            return (
              <TicketRedirect
                {...props}
                screenSize={screenSize}
                history={history}
                webservice={webservice}
                getCookie={getCookie}
                setSessionMessage={setSessionMessage}
              />
            );
          }}
        />
        <Route
          path='/order'
          render={(props) => {
            return (
              <Order
                {...props}
                device={device}
                history={history}
                webservice={webservice}
                getCookie={getCookie}
                screenSize={screenSize}
                orderData={orderData}
                setOrderData={setOrderData}
                setSessionMessage={setSessionMessage}
              />
            );
          }}
        />
        <Route
          path='/ordermx'
          render={(props) => {
            return (
              <OrderMx
                {...props}
                device={device}
                history={history}
                webservice={webservice}
                getCookie={getCookie}
                screenSize={screenSize}
                setSessionMessage={setSessionMessage}
                orderData={orderData}
                setOrderData={setOrderData}
              />
            );
          }}
        />
        <Route
          path={`/ticketapp/:irelandPayTransactionToken?`}
          render={(props) => {
            return (
              <Ticket
                {...props}
                device={device}
                history={history}
                webservice={webservice}
                getCookie={getCookie}
                setSessionMessage={setSessionMessage}
              />
            );
          }}
        />
        <Route
          path={`/paymentios/:irelandPayTransactionToken`}
          render={(props) => {
            return (
              <Payment
                {...props}
                device={device}
                history={history}
                webservice={webservice}
                getCookie={getCookie}
                setSessionMessage={setSessionMessage}
                ostype='ios'
              />
            );
          }}
        />
        <Route
          path={`/paymentandroid/:irelandPayTransactionToken`}
          render={(props) => {
            return (
              <Payment
                {...props}
                device={device}
                history={history}
                webservice={webservice}
                getCookie={getCookie}
                setSessionMessage={setSessionMessage}
                ostype='android'
              />
            );
          }}
        />
        <Route
          path={`/paymentreact/:irelandPayTransactionToken`}
          render={(props) => {
            return (
              <Payment
                {...props}
                device={device}
                history={history}
                webservice={webservice}
                getCookie={getCookie}
                setSessionMessage={setSessionMessage}
                ostype='react'
              />
            );
          }}
        />
        <Route
          path={`/contractus`}
          render={(props) => {
            return (
              <ContractIndex
                {...props}
                device={device}
                history={history}
                webservice={webservice}
                getCookie={getCookie}
                setSessionMessage={setSessionMessage}
                typecontract='newus'
              />
            );
          }}
        />
        <Route
          path={`/magazinesuccess`}
          render={(props) => {
            return <MagazineSuccess {...props} screenSize={screenSize} history={history} />;
          }}
        />
        <Route
          path='/'
          render={(props) => {
            return (
              <Sign
                {...props}
                screenSize={screenSize}
                history={history}
                webservice={webservice}
                getCookie={getCookie}
              />
            );
          }}
        />
      </Switch>
    </div>
  );
};

function App({ history, userAgent = null }) {
  return (
    <Suspense fallback={<Loadingpage />}>
      <Terramar history={history} userAgent={userAgent} />
    </Suspense>
  );
}

export default App;
